import { findByPath } from './utils';
var USER_DOMAIN = '_';
var DOMAINS = ['wix.com', 'editorx.com'];
var REGEX_CAPTURE_PROTO_FIELD = /{(.*)}/;
var REGEX_CAPTURE_DOMAINS = new RegExp("\\.(" + DOMAINS.join('|') + ")$");
export function resolveUrl(opts) {
    var domain = resolveDomain(opts.host);
    var mappings = resolveMappingsByDomain(domain, opts.domainToMappings);
    var path = injectDataIntoProtoPath(opts.protoPath, opts.data || {});
    return resolvePath(path, mappings);
}
function injectDataIntoProtoPath(protoPath, data) {
    return protoPath
        .split('/')
        .map(function (path) { return maybeProtoPathToData(path, data); })
        .join('/');
}
function maybeProtoPathToData(protoPath, data) {
    var field = (protoPath.match(REGEX_CAPTURE_PROTO_FIELD) || [])[1];
    if (field) {
        return findByPath(data, field);
    }
    return protoPath;
}
function resolveDomain(host) {
    return host.replace(REGEX_CAPTURE_DOMAINS, '._base_domain_');
}
function resolveMappingsByDomain(domain, domainToMappings) {
    var mappings = domainToMappings[domain] || domainToMappings[USER_DOMAIN];
    if (!mappings) {
        // todo: fallback? throw?
    }
    return mappings;
}
function resolvePath(protoPath, mappings) {
    var mapping = mappings === null || mappings === void 0 ? void 0 : mappings.find(function (m) { return protoPath.startsWith(m.destPath); });
    if (!mapping) {
        // todo: should we return the path? if no - what should we do in case of testings?
        return protoPath;
    }
    return mapping.srcPath + protoPath.slice(mapping.destPath.length);
}
//# sourceMappingURL=url-resolver.js.map